// Mock data for ZenCodex Technologies website

export const services = [
  {
    id: 1,
    title: "ERP Solutions",
    description: "Custom ERP Development, Inventory Management, CRM, Finance, HRMS",
    icon: "Package",
    image: "https://images.pexels.com/photos/7988079/pexels-photo-7988079.jpeg"
  },
  {
    id: 2,
    title: "Cloud Architecture",
    description: "AWS, Azure, GCP Architecture Design",
    icon: "Cloud",
    image: "https://images.pexels.com/photos/1181341/pexels-photo-1181341.jpeg"
  },
  {
    id: 3,
    title: "Cloud Cost Optimization",
    description: "Reduce Cloud Spending by 20-60%",
    icon: "TrendingDown",
    image: "https://images.pexels.com/photos/5475793/pexels-photo-5475793.jpeg"
  },
  {
    id: 4,
    title: "Web Application Development",
    description: "Enterprise-grade Web Applications",
    icon: "Globe",
    image: "https://images.pexels.com/photos/6803543/pexels-photo-6803543.jpeg"
  },
  {
    id: 5,
    title: "Mobile App Development",
    description: "Android & iOS Applications",
    icon: "Smartphone",
    image: "https://images.pexels.com/photos/7688549/pexels-photo-7688549.jpeg"
  },
  {
    id: 6,
    title: "Website Development",
    description: "Corporate Websites, Portals, E-commerce",
    icon: "Layout",
    image: "https://images.pexels.com/photos/89724/pexels-photo-89724.jpeg"
  },
  {
    id: 7,
    title: "AI Automation",
    description: "Business Process Automation using AI",
    icon: "Cpu",
    image: "https://images.pexels.com/photos/32778341/pexels-photo-32778341.jpeg"
  },
  {
    id: 8,
    title: "DevOps & CI/CD",
    description: "Automated Deployment Pipelines",
    icon: "GitBranch",
    image: "https://images.pexels.com/photos/7988079/pexels-photo-7988079.jpeg"
  }
];

export const whyChooseUs = [
  { id: 1, title: "Certified Cloud Experts", icon: "Award" },
  { id: 2, title: "ERP Specialists", icon: "Users" },
  { id: 3, title: "Cost Optimization Experts", icon: "DollarSign" },
  { id: 4, title: "Agile Development Process", icon: "Zap" },
  { id: 5, title: "Secure & Scalable Solutions", icon: "Shield" },
  { id: 6, title: "24/7 Technical Support", icon: "Clock" },
  { id: 7, title: "Fast Delivery", icon: "Rocket" },
  { id: 8, title: "Enterprise-Grade Architecture", icon: "Building" }
];

export const industries = [
  { id: 1, name: "Manufacturing", icon: "Factory" },
  { id: 2, name: "Healthcare", icon: "Heart" },
  { id: 3, name: "Retail", icon: "ShoppingCart" },
  { id: 4, name: "Logistics", icon: "Truck" },
  { id: 5, name: "Education", icon: "GraduationCap" },
  { id: 6, name: "Finance", icon: "Landmark" },
  { id: 7, name: "Real Estate", icon: "Home" },
  { id: 8, name: "E-commerce", icon: "Store" }
];

export const processSteps = [
  {
    id: 1,
    title: "Discovery & Consultation",
    description: "Understanding your business needs and objectives"
  },
  {
    id: 2,
    title: "Solution Design",
    description: "Creating tailored architecture and design"
  },
  {
    id: 3,
    title: "Development",
    description: "Building with best practices and modern technologies"
  },
  {
    id: 4,
    title: "Testing & QA",
    description: "Rigorous testing for quality assurance"
  },
  {
    id: 5,
    title: "Deployment",
    description: "Smooth launch and go-live process"
  },
  {
    id: 6,
    title: "Support & Optimization",
    description: "Ongoing support and continuous improvement"
  }
];

export const cloudCostFeatures = [
  { id: 1, title: "Cloud Infrastructure Assessment", icon: "Search" },
  { id: 2, title: "Cost Analysis", icon: "BarChart" },
  { id: 3, title: "Resource Optimization", icon: "Settings" },
  { id: 4, title: "Rightsizing Recommendations", icon: "Target" },
  { id: 5, title: "Reserved Instance Strategy", icon: "Calendar" },
  { id: 6, title: "Monthly Cost Monitoring", icon: "Activity" }
];

export const cloudCostStats = [
  { id: 1, value: "60%", label: "Cost Reduction" },
  { id: 2, value: "40%", label: "Performance Boost" },
  { id: 3, value: "99.9%", label: "Uptime Guaranteed" },
  { id: 4, value: "24/7", label: "Monitoring" }
];

export const portfolio = [
  {
    id: 1,
    title: "ERP System for Manufacturing",
    description: "Complete inventory and production management system",
    technologies: ["React", "Node.js", "PostgreSQL", "AWS"],
    category: "ERP",
    image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxlbnRlcnByaXNlJTIwc29mdHdhcmUlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzgxNzk5NDg2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Healthcare Management Platform",
    description: "Patient records, appointments, and billing management",
    technologies: ["Vue.js", "Python", "MongoDB", "Azure"],
    category: "Healthcare",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxlbnRlcnByaXNlJTIwc29mdHdhcmUlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzgxNzk5NDg2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "E-Commerce Marketplace",
    description: "Multi-vendor marketplace with advanced features",
    technologies: ["React", "Laravel", "MySQL", "AWS"],
    category: "E-commerce",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxlbnRlcnByaXNlJTIwc29mdHdhcmUlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzgxNzk5NDg2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Logistics Tracking Application",
    description: "Real-time shipment tracking and fleet management",
    technologies: ["React Native", "FastAPI", "Redis", "GCP"],
    category: "Logistics",
    image: "https://images.unsplash.com/photo-1720962158789-9389a4f399da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHx0ZWNobm9sb2d5JTIwaW50ZXJmYWNlfGVufDB8fHx8MTc4MTc5OTQ5NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Cloud Migration Project",
    description: "Migrated legacy infrastructure to AWS cloud",
    technologies: ["AWS", "Kubernetes", "Docker", "Terraform"],
    category: "Cloud",
    image: "https://images.pexels.com/photos/5380618/pexels-photo-5380618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 6,
    title: "AI Automation Solution",
    description: "Intelligent document processing and workflow automation",
    technologies: ["Python", "TensorFlow", "FastAPI", "AWS"],
    category: "AI",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwaW50ZXJmYWNlfGVufDB8fHx8MTc4MTc5OTQ5NXww&ixlib=rb-4.1.0&q=85"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Mitchell",
    company: "TechCorp Industries",
    role: "CTO",
    rating: 5,
    review: "ZenCodex transformed our legacy systems into a modern cloud-native architecture. Their expertise in ERP and cloud optimization saved us 45% in infrastructure costs."
  },
  {
    id: 2,
    name: "Sarah Johnson",
    company: "MediCare Solutions",
    role: "Director of IT",
    rating: 5,
    review: "Outstanding work on our healthcare management platform. The team delivered a HIPAA-compliant solution that exceeded our expectations. Highly professional!"
  },
  {
    id: 3,
    name: "David Chen",
    company: "Global Logistics Ltd",
    role: "CEO",
    rating: 5,
    review: "The logistics tracking application they built has streamlined our entire operation. Real-time tracking and analytics have improved our efficiency by 60%."
  },
  {
    id: 4,
    name: "Maria Garcia",
    company: "RetailHub Inc",
    role: "Operations Manager",
    rating: 5,
    review: "Our e-commerce platform handles thousands of transactions daily without any issues. ZenCodex's expertise in scalable architecture is truly impressive."
  }
];